<div fxLayout="row wrap" fxLayoutAlign="space-between">
  <h2 fxFlex="1 1 auto" mat-dialog-title>Bild zuschneiden</h2>
  <div class="actions" fxFlex="0 0 auto">
    <mat-icon (click)="onZoom(0.1)">zoom_in</mat-icon>
    <mat-icon (click)="onZoom(-0.1)">zoom_out</mat-icon>
  </div>
</div>
<div mat-dialog-content>
  <div class="img-container">
    <img #image [src]="data.imageUrl | safeUrl" alt="Neues Bild hochladen">
  </div>
</div>
<mat-dialog-actions align="end">
  <button (click)="onNoClick()" mat-button>Abbrechen</button>
  <button (click)="onYesClick()" cdkFocusInitial mat-raised-button>Hochladen</button>
</mat-dialog-actions>


